import { VehicleEnrollment } from './vehicle-enrollment.model';

export interface PolicyEnrollment {
  policyNumber: string;
  enrolledVehicles: VehicleEnrollment[];
}
